import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../../core/services/storage.service';
import { UserProfileService } from '../../../core/services/user-profile.service';
import { Configuration } from './../../../config/configuration';

@Component({
  selector: 'sigv-no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss'],
})
export class NoPermissionComponent implements OnInit {
  constructor(
    private router: Router,
    private configuration: Configuration,
    private storageService: StorageService,
    private userProfileService: UserProfileService
  ) {}

  ngOnInit(): void {}

  goHome(): void {
    this.clearLoginData();
    this.router.navigate([this.configuration.routePath.index]);
  }

  /**
  * @description 清除登入資訊
  */
  clearLoginData(): void {
    this.userProfileService.currentUserSubject.next(null);
    this.userProfileService.currentSystemPermissionsSubject.next([]);
    this.storageService.userProfile.removeItem();
    this.storageService.idToken.removeItem();
  }
}
